import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function SalesmansPrint(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    const num = 12;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={20} docNamePdf={"SalesmansPrint.pdf"} docName={"SalesmansPrint"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
